import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { SmallSizedField } from '../models/models';

import { InfrastructureService } from './infrastructure.service';

@Injectable({
  providedIn: 'root',
})
export class SmallSizedFieldService extends InfrastructureService<SmallSizedField> {
  protected readonly endpoint: string = '/SmallSizedFields';

  constructor(protected http: HttpClient) {
    super(http);
  }

}
